import { getApi, postApi } from "./api";

export const AddInventry = async (data) => {
  try {
    const response = await postApi(
      "/Inventory/addinventory", data
    );
    return response;

  } catch (error) {
    console(error);
    throw error.response?.data || error.message;
  }
};

export const Updateinventry = async (data) => {
  try {
    const response = await postApi(
      "/Inventory/updateinventory", data
    );
    return response;

  } catch (error) {
    console(error);
    throw error.response?.data || error.message;
  }
};

export const GetTransactionTypes = async () => {
    return await getApi("/Inventory/transactiontypes");
};

export const GetAllTransaction = async () => {
    return await getApi("/Inventory/GetAllInventory");
};

export const GetAllTransactionHis = async () => {
    return await getApi("/Inventory/GetAll");
};